import dashboard from './dashboard';
import policies from './policies';
import portfolio from './portfolio';
import profile from './profile';
import requests from './requests';

export default [
    ...dashboard,
    ...profile,
    ...requests,
    ...portfolio,
    ...policies,
]
